import ActionTypes from "./types";
import announcementAPIHelper from "../../helpers/api/annoucementAPIHelper";

/**
 * Get list for announcements
 * @param {String} [token=null] (Optional) Token for API calling, default using the application token of user site. Reserved for staff login.
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
function getList(
  token = null,
  successCallback = null,
  failCallback = null,
  carpark = null
) {
  return (dispatch) => {
    announcementAPIHelper.getList(
      token,
      carpark,
      (response) => {
        const {
          responseDetail: { data },
        } = response;
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_GET_LIST,
          data,
        });
        if (typeof successCallback === "function") successCallback(data);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

const AnnouncementActions = { getList };
export default AnnouncementActions;
